module.exports = __webpack_public_path__ + "static/media/gothamist_vertical_01.96db4084.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gothamist_vertical_01.svg
// module id = 195
// module chunks = 0